module.exports = __webpack_public_path__ + "img/knus_main1.beb07980.jpg";